module.exports = __webpack_public_path__ + "static/media/audiman.f3a67f93.jpg";